import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import AutoComplete from 'material-ui/AutoComplete';
import SmartTag from './SmartTag';


export default class TagsPopup extends React.Component {

  constructor() {
    super();
    this.state = {
      inputVisible: true,
      dataSource: [{
        textKey: 'python',
        valueKey: 'python2',
      }, {
        textKey: 'django',
        valueKey: 'django2',
      }],
    };
  }

  render() {
    const { searchText } = this.state;
    const {
      open, molecule, tags, existingTags, tagsPopupError, onCancel,
      addTag, removeTag, getTags
    } = this.props;
    return (
      <div>
        <Dialog
          title="Tag molecule"
          titleStyle={{
            color: '#fff',
            backgroundColor: 'rgb(26, 198, 255)',
          }}
          actions={[
            <FlatButton
              label="Done"
              primary={true}
              onTouchTap={() => {
                if (onCancel) {
                  onCancel();
                }
              }}
            />,
          ]}
          modal={false}
          open={open}
          onRequestClose={() => {
            if (onCancel) {
              onCancel();
            }
          }}
          autoScrollBodyContent={true}
        >
          <br />
          <h5>Tags on the molecule:</h5>
          <div style={{display: 'flex', flexWrap: 'wrap'}}>
            {existingTags.map((tag, index) => {
              return (<SmartTag
                key={tag.name}
                tag={tag}
                style={{margin: 4, }}
                onRequestDelete={(e) => {
                  if (removeTag) {
                    removeTag(tag, molecule);
                  }
                }}
              />);
            })}
          </div>
          <br />
          <h5 style={{marginBottom: 0}}>Add new tags on the molecule:</h5>
          <div>
            <AutoComplete
              hintText="Type tag here"
              dataSource={tags}
              dataSourceConfig={{text: 'name', value: 'fp'}}
              floatingLabelText="New Molecule Tag"
              errorText={tagsPopupError}
              fullWidth={true}
              autoFocus={true}
              // openOnFocus={true}
              searchText={searchText}
              onUpdateInput={(text) => {
                this.setState({searchText: text});
                if (getTags) {
                  getTags(text, molecule);
                }
              }}
              onNewRequest={() => {
                if (addTag) {
                  addTag(searchText, molecule);
                }
                this.setState({
                  searchText: '',
                });
                this.inputSearch.focus();
              }}
              filter={(searchText, key) => (key.indexOf(searchText) !== -1)}
              ref={(input) => {
                this.inputSearch = input;
              }}
            />
          </div>
        </Dialog>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/TagsPopup.jsx